<template>
  <div class="newsList ztzl">
    <!-- 专题专栏 -->
    <div class="content">
      <div class="chanpincon">
        <div class="inner">
          <!-- 导航 -->
          <div class="childnav">
            <div class="desc">
              <img src="/statics/image/index/icon.png" alt />
              <span>{{cateact.title}}</span>
            </div>
            <el-tabs :tab-position="tabPosition" v-model="activeName" @tab-click="handleClick">
              <el-tab-pane v-for="(item,index) in s_cates" :key="index" :name="item.id.toString()">
                <a
                  href="javascript:scroll(0,0)"
                  slot="label"
                  v-if="item.title"
                  :style="!item.display?'display: none;':''"
                >{{item.title}}</a>
              </el-tab-pane>
            </el-tabs>
          </div>
          <!-- 右侧内容 -->
          <div class="news_right">
            <!-- 面包屑导航 -->
            <div class="mbnav">
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">
                  <img class="homeIcon" src="/statics/image/index/home.png" alt />
                  首页
                </el-breadcrumb-item>
                <el-breadcrumb-item>专题专栏</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
            <div class="zt_list">
              <div
                class="zt_item"
                v-for="(item,index) in zlS_cates"
                :key="index"
                @click="toInfo(item.id)"
                :style="(!item.display)||(item.id=='131')?'display:none':''"
              >
                <img class="ztpic" :src="adddom(item.thumb)" alt="pic" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabPosition: "left", //导航对齐方式
      activeName: null,
      // nowid: "",
      nowindex: "",
      s_cates: [], //二级分类
      zlS_cates: [], //专栏二级分类
      cateact: { title: "" },
      article: {},
      fromName: "",
      xqIndex: "" //新区要闻下标
    };
  },
  created() {
    // this.nowid = this.$route.query.id;
    // this.nowindex = this.$route.query.index;
    this.getNav();
  },
  methods: {
    // 图片拼接地址
    adddom(src) {
      if (src == "" || src == undefined || src == null) {
        // console.log("src地址有问题");
        return "";
      }
      if (src.substr(0, 4).toLowerCase() === "http") {
        return src;
      }
      return this.$url + src;
    },
    // 获取导航
    getNav() {
      // this.nowid = this.$route.query.id;
      this.nowindex = this.$route.query.index;
      var that = this;
      that.$api.index.catelist({}).then(function(res) {
        if (res.code == 200) {
          for (var i in res.result.all_cate) {
            if (res.result.all_cate[i].id == 12) {
              that.xqIndex = i;
            }
            if (res.result.all_cate[i].id == 29) {
              that.zlS_cates = res.result.all_cate[i].s_cates;
            }
          }
          that.cateact = res.result.all_cate[that.xqIndex];
          that.s_cates = res.result.all_cate[that.xqIndex].s_cates
            ? res.result.all_cate[that.xqIndex * 1].s_cates
            : [];
          // that.zlS_cates = res.result[that.nowindex].s_cates
          //   ? res.result[that.nowindex * 1].s_cates
          //   : [];
        }
      });
    },
    // 导航选中触发
    handleClick(tab, event) {
      // console.log(tab.name);
      this.$router.push({
        path: "/xqNews",
        query: {
          id: 12,
          index: this.xqIndex,
          dhid: tab.name
        }
      });
    },

    // 点击跳转到新区要闻详情
    toInfo(id) {
      // 测试5515
      if (id == "5554") {
        this.$router.push({
          path: "/ztzl_fk",
          query: {
            index: this.nowindex
          }
        });
      } else {
        this.$router.push({
          path: "/xqNews",
          query: {
            id: 29,
            index: this.nowindex,
            dhid: id
          }
        });
      }
    }
  }
};
</script>

<style>
</style>